/**
	* Localstorage
	* @param <Element>, <Element>
	*/

export default (window, document) => {

    let isModernBrowser = (
        'querySelector' in document &&
        'localStorage' in window &&
        'addEventListener' in window
    ),
        md5 = '9af1d9a0ee8a675d7bd33284eb44dbc7',
        key = 'fonts',
        url = window.location.hostname,
        cache;
    
    if (url == "wwwdev.seppa-dev.ovh") {
        url = "https://wwwdev.seppa-dev.ovh/ares/wp-content/themes/seppa/css/font.json"
    } else {
        url = "https://" + url + "wp-content/themes/seppa/css/font.json"
    }

    console.log(url);

    if (!isModernBrowser) {
        return;
    }

    let insertFont = function (value) {
        let style = document.createElement('style');
        style.innerHTML = value;
        document.head.appendChild(style);
    };

    //PRE RENDER
    try {
        cache = window.localStorage.getItem(key);
        console.log(cache);
        if (cache) {
            cache = JSON.parse(cache);
            if (cache.md5 == md5) {
                insertFont(cache.value);
            } else {
                window.localStorage.removeItem(key);
                cache = null;
            }
        }
    } catch (e) {
        return;
    }

    //POST RENDER
    if (!cache) {
        window.addEventListener('load', () => {
            let request = new XMLHttpRequest(),
                response;
            request.open('GET', url , true);
            request.onload = function () {
                if (this.status == 200) {
                    try {
                        response = JSON.parse(this.response);
                        console.log(response);
                        insertFont(response.value);
                        window.localStorage.setItem(key, this.response);
                    } catch (e) {
                        // LocalStorage is probably full
                    }
                }
            };
            request.send();
        });
    }
};